import { BsFillStarFill } from 'react-icons/bs';

interface StarsProps {
  stars: number;
}

export default function Stars({ stars }: StarsProps) {
  const lstStars = [];

  const spanStyle = {
    color: 'gold',
  };

  for (let i = 0; i < stars; i += 1) {
    lstStars.push(<BsFillStarFill key={i} style={spanStyle} />);
  }

  return <div className="float-end">{lstStars}</div>;
}
